import React, { useCallback, useEffect, useState } from "react";
import ControlsPTDetentionCodeWise from "./ControlsPTDetentionCodeWise";
import GraphPTDetention from "./GraphPTDetention";
import MoreDataForPTDC from "./MoreDataForPTDC";

const PunctualityTrainDetentionCodeWise2 = () => {
  const [data, setData] = useState([]);
  const [legendsData, setLegendsData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [openStates, setOpenStates] = useState({
    Year: false,
    SECTION: false,
    DET_CODE: false,
    SUB_CODE: false,
    TRAIN_NO: false,
  });

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(false);
    const url = `${process.env.REACT_APP_URL_PREFIX}trainlostdetcodesubcodewise?fin_yr_array=2025-2026`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setData(data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="newUiBody">
      <h6 className="p-1 bg-dark text-white">
        {" "}
        Punctuality detention code wise
      </h6>
      <div>
        {" "}
        <ControlsPTDetentionCodeWise
          data={data}
          setFilteredData={setFilteredData}
          openStates={openStates}
          setOpenStates={setOpenStates}
        />
      </div>
      <div
        className="row mt-1"
        onClick={() => {
          setOpenStates({
            Year: false,
            SECTION: false,
            DET_CODE: false,
            SUB_CODE: false,
            TRAIN_NO: false,
          });
        }}
      >
        <div className="col-md-12 ">
          <div className="newUiBody">
            {" "}
            <GraphPTDetention
              data={filteredData}
              setLegendsData={setLegendsData}
            />{" "}
          </div>
        </div>
        <div className="col-md-12">
          <div className="newUiBody">
            <MoreDataForPTDC data={filteredData} legendsData={legendsData} />
          </div>
        </div>
      </div>{" "}
    </div>
  );
};
export default PunctualityTrainDetentionCodeWise2;
